import { CheckIcon } from "./icons";

export default function Toast({ message }) {
  if (!message) return null;
  return (
    <div className="toast-wrap">
      <div className="toast">
        <CheckIcon size={14} stroke="#63CF8E" width={3.2} />
        {message}
      </div>
    </div>
  );
}
